import gql from "graphql-tag"
import SourceAssetFragment from "../fragment/SourceAssetFragment"

export default gql`
  ${SourceAssetFragment}
  mutation sourceAssetApprove($id: String!, $input: SourceAssetApproveInput!) {
    sourceAssetApprove(id: $id, input: $input) {
      ...SourceAssetFragment
    }
  }
`
